// extracted by mini-css-extract-plugin
export default {"rowHasBadge":"mC-z","smallCardRow":"nC-z","largeCardRow":"oC-z","productSearchRow":"pC-z","curatedRow":"qC-z"};